import { observable } from "mobx";
import { Type } from "class-transformer";
import CreditExposureState from "./creditExposureState";
import CreditExposureType from "./creditExposureType";
import type { EntityValidationRules } from "services/validationService";
import { addYears, endOfDay, subDays } from "date-fns";
import { startOfEDAZDistribution } from "config";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CreditExposureDetailResponse {
  id!: string;

  @observable
  @Type(() => Date)
  validSinceDate!: Date;

  @observable
  @Type(() => Date)
  validUntilDate!: Date;

  @observable
  state!: CreditExposureState;

  @observable
  type!: CreditExposureType;

  @observable
  description!: string;

  @observable
  amount!: number;

  @observable
  @Type(() => Date)
  updatedAt?: Date;

  @observable
  updatedUserId!: string;

  @observable
  distributorName!: string;
}

export const CreditExposureDetailValidationRules: EntityValidationRules<CreditExposureDetailResponse> = {
  description: {
    required: true,
    isLength: {
      max: 255,
    },
  },
  type: {
    required: true,
  },
  amount: {
    range: { min: 1, max: 100000000000 },
    required: true,
  },
  validSinceDate: {
    required: true,
    isBefore: {
      condition: (entity: CreditExposureDetailResponse) => entity.validUntilDate,
    },
    isAfter: {
      condition: () => endOfDay(subDays(startOfEDAZDistribution, 1)),
    },
  },
  validUntilDate: {
    required: true,
    isAfter: {
      condition: (entity: CreditExposureDetailResponse) =>
        entity.validSinceDate > new Date() ? entity.validSinceDate : new Date(),
    },
    isBefore: {
      condition: () => endOfDay(addYears(new Date(), 1)),
    },
  },
};
